<template>
	<div class="search">
        <div>
            <label class="control-label" for="t">Title:</label>
            <input class="input" type="text" name="haberSearch" placeholder="Enter Film Name" v-model="query" @keypress.enter="handleSearch">
            &nbsp;&nbsp;
            <label class="control-label" for="y">Year:</label>
            <input type="text" id="y" name="y" class="input" style="width: 100px;">
            &nbsp;&nbsp;
            <label class="control-label">Plot:</label>
            <select name="plot" class="input plot">
                <option class="plot" value="" selected="">Short</option>
                <option class="plot" value="full">Full</option>
            </select>
            <button v-on:click="handleSearch">Search</button>
        </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				query:''
			}
		},
	
	methods:{
		handleSearch(){
			if (this.query=="") {	
				alert("Please enter a title");
			}
			else{
				this.$emit('SearchRequested', this.query);
			}
		}
	}
}
</script>

<style> 
	.search input{
		padding: 10px;
		width: 400px;
		border-radius: 5px;
	}
	.search button{
		padding: 10px;
		width: 100px;
        height: 40px;
		border-radius: 5px;
		background-color:#fa8231;
		color:#444444;
        font-size: 15px;
        font-weight: bold;
        border: none;
        cursor: pointer;
	}
    .input {
        border-color: #fa8231;
        border-style: solid;
    }
    .plot {
        width: 70px;
        height: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/search.vue